import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import CircleLinkList from '../../ui-components/CircleLinkList/CircleLinkList';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { listTrackingEvent } from '../../utils/statistics/customEvents';
import { createImageProxyTemplate } from '../../utils/svtimage';

class RelatedCategories extends React.Component {
    constructor(props) {
        super(props);
        this.onExpand = this.onExpand.bind(this);
        this.state = {
            expanded: props.router.asPath.includes('#visa-relaterade'),
        };
    }

    onExpand(event) {
        event.preventDefault();

        this.props.router.replace(
            {
                pathname: this.props.router.asPath,
            },
            `${this.props.router.asPath}#visa-relaterade`
        );

        this.setState({ expanded: true });
    }

    trackRelatedCategory(e, category) {
        const clickTarget = e.currentTarget;
        trackCustomEvent(listTrackingEvent(category.relatedCategoriesTracking, clickTarget));
    }

    render() {
        const { router, category, headerText, relatedCategories } = this.props;
        const { expanded } = this.state;

        if (!relatedCategories.length) {
            return null;
        }

        const categories = relatedCategories.map((item, index) => {
            const relatedCategoriesTracking = {
                listType: 'kategorier',
                listID: `kategorilista ${category}`,
                listItemIndex: index,
                listExpandedState: null,
                contentId: item.id,
            };

            return {
                name: item.heading,
                slug: item.id,
                thumbnailImage: item.image
                    ? createImageProxyTemplate(item.image.id, String(item.image.changed))
                    : '',
                imageAltText: item.image.description,
                relatedCategoriesTracking: relatedCategoriesTracking,
            };
        });

        return (
            <CircleLinkList
                heading={headerText}
                items={categories}
                location={router.asPath}
                expanded={expanded}
                onExpand={this.onExpand}
                onItemClick={this.trackRelatedCategory}
            />
        );
    }
}

RelatedCategories.propTypes = {
    category: PropTypes.string.isRequired,
};

export default withRouter(RelatedCategories);
